import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectMenuList } from '../../redux/menu-item/menu-item.selector';
import MenuItems from '../menu-items/menu-items.component';

import './category-item.style.css';

const categoryItem = ({img, cat_descrip, category, menuItem }) => {

    return (
        <div id={`${category.split(' ').join('')}`}>
            <div className="menu_contain" >
                <img src={img} alt="category" />
                <div style={{ paddingLeft: "10px", lineHeight: "20px", color: "black" }}>

                    <p className="menu_heading" >{category}</p>
                    <p className="menu_sub">{cat_descrip}</p>

                </div>

            </div>
            
            {menuItem &&
                menuItem.map(({id, ...otherProps}) => (
                    <MenuItems key={id} id={id} {...otherProps}/>
                ))
            }

        </div>
    )
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({
    menuItem: selectMenuList(ownProps.id)
})

export default connect(mapStateToProps)(categoryItem);